import script from "./Pane2.vue?vue&type=script&setup=true&lang=js"
export * from "./Pane2.vue?vue&type=script&setup=true&lang=js"

import "./Pane2.vue?vue&type=style&index=0&id=fb0be6ea&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb0be6ea"]])

export default __exports__